// extracted by mini-css-extract-plugin
module.exports = {"container":"members_container__1zvVQ","title":"members_title__360OT","content":"members_content__BukrG"};